export default {
  auction: [
    {
      id: 'cpm',
      name: 'CPM',
    },
    {
      id: 'normalized-cpm',
      name: 'Normalized CPM',
    },
  ],
  prioritize: [
    {
      id: 'ssps',
      name: 'SSPs',
    },
    {
      id: 'advertisers',
      name: 'Advertisers',
    },
    {
      id: 'buyers',
      name: 'Buyers',
    },
  ],
};
